import type React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { motion } from "framer-motion";
import logoBrown from "../../../../assets/logoBrown.png";
import type { IExpandedCallSheetData } from "../../../../types/callsheet";
import { CrewEntry } from "./types/callsheet";

interface CallSheetHeaderProps {
  callSheetData: IExpandedCallSheetData;
  crewMembers?: CrewEntry[];
}

const CallSheetHeader: React.FC<CallSheetHeaderProps> = ({
  callSheetData,

  crewMembers,
}) => {
  const isExecutiveProducer = (role?: string) =>
    role?.toLowerCase() === "executive producer";

  const executiveProducerEntry = crewMembers?.find(
    (entry) =>
      entry.roles?.some((r) => isExecutiveProducer(r.name)) ||
      entry.assignment?.some((a) => isExecutiveProducer(a.role))
  );

  const isProducer = (role?: string) => role?.toLowerCase() === "producer";

  const producerEntry = crewMembers?.find(
    (entry) =>
      entry.roles?.some((r) => isProducer(r.name)) ||
      entry.assignment?.some((a) => isProducer(a.role))
  );
  const executiveProducer = executiveProducerEntry
    ? {
        name: `${executiveProducerEntry.crew_member.user.first_name} ${executiveProducerEntry.crew_member.user.last_name}`,
        email: executiveProducerEntry.crew_member.user.email,
      }
    : null;

  const producer = producerEntry
    ? {
        name: `${producerEntry.crew_member.user.first_name} ${producerEntry.crew_member.user.last_name}`,
        email: producerEntry.crew_member.user.email,
      }
    : null;

  return (
    <motion.div
      initial={{ x: -20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 0.3 }}
    >
      <img
        alt="Muzukuru logo"
        width="160px"
        height="60px"
        src={logoBrown || "/placeholder.svg"}
        style={{ cursor: "pointer" }}
      />
      <Divider sx={{ my: 2 }} />

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {callSheetData?.booking?.company?.name || "N/A"}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {callSheetData?.booking?.company?.name || "N/A"}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
          Executive Producer:
        </Typography>
        <Typography variant="body2">
          {executiveProducer?.name || "Joseph Bunga"}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {executiveProducer?.email || "joe@area46.co.zw"}
        </Typography>

        <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
          Producer:
        </Typography>
        <Typography variant="body2">{producer?.name || "N/A"}</Typography>
        <Typography variant="body2" color="text.secondary">
          {producer?.email || "N/A"}
        </Typography>
      </Box>
    </motion.div>
  );
};

export default CallSheetHeader;
